export const state = {
    fabricante: {},
    fabricantes: [],
    modalExcluirFabricante: false,
    modalCadastrarFabricante: false,
}

export default {}